import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Ticket, Loader2, Calendar, MapPin } from 'lucide-react';

const STATUT_BADGE = { valide: 'badge-success', utilise: 'badge-neutral', rembourse: 'badge-warning', annule: 'badge-danger' };
const STATUT_LABEL = { valide: 'Valide', utilise: 'Utilisé', rembourse: 'Remboursé', annule: 'Annulé' };

export default function MemberBillets() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get('/billets/mes-billets'); setList(data); }
      catch {} finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="p-8 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-[#94A3B8]" /></div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 lg:py-12" data-testid="member-billets">
      <div className="mb-8 slide-up">
        <div className="label-uppercase mb-2" style={{ color: 'var(--theme-primary)' }}>Mes billets</div>
        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A]">{list.length} billet{list.length > 1 ? 's' : ''}</h1>
      </div>

      {list.length === 0 ? (
        <div className="card text-center py-16">
          <Ticket className="w-10 h-10 mx-auto mb-3 text-[#CBD5E1]" />
          <p className="text-[#475569] text-sm">Aucun billet pour l'instant.</p>
        </div>
      ) : (
        <div className="space-y-4 stagger" data-testid="member-billets-list">
          {list.map((b) => (
            <div key={b.id} className="card !p-0 overflow-hidden flex flex-col sm:flex-row" data-testid={`billet-${b.id}`}>
              <div className="flex-1 p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-display text-lg font-bold text-[#0F172A]">{b.evenement_nom}</h3>
                  <span className={`badge ${STATUT_BADGE[b.statut]}`}>{STATUT_LABEL[b.statut]}</span>
                </div>
                <div className="space-y-1.5 text-xs text-[#475569]">
                  <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-[#94A3B8]" /> {new Date(b.date_debut).toLocaleString('fr-FR', { dateStyle: 'full', timeStyle: 'short' })}</div>
                  {b.lieu && <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#94A3B8]" /> {b.lieu}</div>}
                  {b.categorie && <div className="text-[#475569]"><span className="text-[#94A3B8]">Catégorie :</span> {b.categorie}</div>}
                  {b.prix_paye > 0 && <div className="text-[#475569]"><span className="text-[#94A3B8]">Prix :</span> {Number(b.prix_paye).toFixed(2)}€</div>}
                </div>
              </div>
              {/* QR side */}
              <div className="border-t sm:border-t-0 sm:border-l border-dashed border-[#E2E8F0] relative p-6 grid place-items-center min-w-[200px]" style={{ background: 'var(--theme-primary)' }}>
                <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white hidden sm:block" />
                <div className="absolute -left-3 -top-3 sm:hidden w-6 h-6 rounded-full bg-white" />
                <div className="absolute -right-3 -top-3 sm:hidden w-6 h-6 rounded-full bg-white" />
                <div className="text-center" style={{ color: 'var(--theme-primary-foreground)' }}>
                  <div className="text-[10px] uppercase tracking-widest opacity-70 mb-2">Code billet</div>
                  <div className="font-mono text-2xl font-black tracking-widest">{b.qr_code?.slice(0, 8).toUpperCase()}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
